import { signup, login } from '../../../api';
import { call, takeLatest, put, delay } from 'redux-saga/effects';
import {
  REQUEST_A_SIGNUP_LINK,
  REQUEST_A_SIGNUP_LINK_START,
  REQUEST_A_SIGNUP_LINK_COMPLETE,
  REQUEST_A_SIGNUP_LINK_ERROR,
  VERIFY_PHONE_NUMBER,
  VERIFY_PHONE_NUMBER_START,
  VERIFY_PHONE_NUMBER_COMPLETE,
  VERIFY_PHONE_NUMBER_ERROR,
  VERIFY_PHONE_NUMBER_OTP,
  VERIFY_PHONE_NUMBER_OTP_START,
  VERIFY_PHONE_NUMBER_OTP_COMPLETE,
  VERIFY_PHONE_NUMBER_OTP_ERROR,
  CREATE_PASSWORD,
  CREATE_PASSWORD_START,
  CREATE_PASSWORD_COMPLETE,
  CREATE_PASSWORD_ERROR,
  VERIFY_EMAIL,
  VERIFY_EMAIL_START,
  VERIFY_EMAIL_COMPLETE,
  VERIFY_EMAIL_ERROR,
} from './actions';
import errorStrings from '../../../constants/errorStrings';
import { setAuthDetails } from '../../../utils/AuthDetailsUtil';
import {getUserProfile} from '../userProfile/saga';

export function* requestASignupLink({ payload: { params, onSuccess } }) {
  try {
    yield put({
      type: REQUEST_A_SIGNUP_LINK_START,
    });
    const { response, error } = yield call(signup.requestASignupLink, {
      params,
    });

    if (!!response) {
      yield put({
        type: REQUEST_A_SIGNUP_LINK_COMPLETE,
      });
      yield call(onSuccess);
    } else {
      yield put(
        onRequestASignupLinkError({
          error: error?.data.message ? error?.data.message : errorStrings.commonError,
        }),
      );
    }
  } catch (error) {
    yield put(
      onRequestASignupLinkError({
        error: errorStrings.commonError,
      }),
    );
  }
}

export function* verifyEmail({
  payload: { token, onSuccessOfEmailVerification, onError },
}) {
  try {
    yield put({
      type: VERIFY_EMAIL_START,
    });

    const { response, error } = yield call(signup.verifyEmail, {
      token,
    });
    if (!!response) {
      yield put({
        type: VERIFY_EMAIL_COMPLETE,
        payload: {
          data: response.token,
        },
      });
      onSuccessOfEmailVerification();
    } else {
      yield put(
        onVerifyEmailError({
          error: error?.data.message ? error?.data.message : errorStrings.commonError,
        }),
      );
    }
  } catch (error) {
    yield put(
      onVerifyEmailError({
        error: errorStrings.commonError,
      }),
    );
  }
}

export function* verifyPhoneNumber({
  payload: { params, onSuccessOfPhoneNumberVerification, onError },
}) {
  try {
    yield put({
      type: VERIFY_PHONE_NUMBER_START,
    });

    const { response, error } = yield call(signup.verifyPhoneNumber, {
      params,
    });

    if (!!response) {
      yield put({
        type: VERIFY_PHONE_NUMBER_COMPLETE,
        payload: {
          data: response.token,
        },
      });
      onSuccessOfPhoneNumberVerification?.();
    } else {
      yield put(
        onVerifyPhoneNumberError({
          error: error?.data.message ? error?.data.message : errorStrings.commonError,
        }),
      );
    }
  } catch (error) {
    yield put(
      onVerifyPhoneNumberError({
        error: errorStrings.commonError,
      }),
    );
  }
}

export function* verifyPhoneNumberOtp({
  payload: { params, onSuccessOfOtpVerification, onError },
}) {
  try {
    yield put({
      type: VERIFY_PHONE_NUMBER_OTP_START,
    });
    const { response, error } = yield call(signup.verifyPhoneNumberOtp, {
      params,
    });

    if (!!response) {
      yield put({
        type: VERIFY_PHONE_NUMBER_OTP_COMPLETE,
        payload: { data: response.token },
      });
      onSuccessOfOtpVerification();
    } else {
      yield put(
        onVerifyPhoneNumberOtpError({
          error: error?.data.message ? error?.data.message : errorStrings.commonError,
        }),
      );
    }
  } catch (error) {
    yield put(
      onVerifyPhoneNumberOtpError({
        error: errorStrings.commonError,
      }),
    );
  }
}

export function* createPassword({
  payload: { params, forgotPassword = false, onSuccessOfCreatePassword, onError },
}) {
  try {
    yield put({
      type: CREATE_PASSWORD_START,
    });
    var { response, error } = yield call(signup.createPassword, {
      params,
    });

    if (!!response) {
      if (!forgotPassword) {
        var { refresh: refresh_token } = response;
        var { success, error } = yield call(login.fetchAuthToken, {
          refresh_token,
        });
        yield delay(5000);
        if (success) {
          yield call(getUserProfile);
          yield put({
            type: CREATE_PASSWORD_COMPLETE,
          });
          onSuccessOfCreatePassword();
        } else {
          yield put(
            onCreatePasswordError({
              error: error?.data.message ? error?.data.message : errorStrings.commonError,
            }),
          );
        }
      } else {
        yield put({
          type: CREATE_PASSWORD_COMPLETE,
        });

        onSuccessOfCreatePassword();
      }
    } else {
      yield put(
        onCreatePasswordError({
          error: error?.data.message ? error?.data.message : errorStrings.commonError,
        }),
      );
    }
  } catch (error) {
    yield put(
      onCreatePasswordError({
        error: errorStrings.commonError,
      }),
    );
  }
}

const onVerifyPhoneNumberOtpError = (payload = {}) => ({
  type: VERIFY_PHONE_NUMBER_OTP_ERROR,
  payload,
});

const onCreatePasswordError = (payload = {}) => ({
  type: CREATE_PASSWORD_ERROR,
  payload,
});

const onRequestASignupLinkError = (payload = {}) => ({
  type: REQUEST_A_SIGNUP_LINK_ERROR,
  payload,
});

const onVerifyPhoneNumberError = (payload = {}) => ({
  type: VERIFY_PHONE_NUMBER_ERROR,
  payload,
});

const onVerifyEmailError = (payload = {}) => ({
  type: VERIFY_EMAIL_ERROR,
  payload,
});

function* watchVerifyEmail() {
  yield takeLatest(VERIFY_EMAIL, verifyEmail);
}

function* watchCreatePassword() {
  yield takeLatest(CREATE_PASSWORD, createPassword);
}

function* watchVerifyPhoneNumberOtp() {
  yield takeLatest(VERIFY_PHONE_NUMBER_OTP, verifyPhoneNumberOtp);
}

function* watchRequestASignupLink() {
  yield takeLatest(REQUEST_A_SIGNUP_LINK, requestASignupLink);
}

function* watchVerifyPhoneNumber() {
  yield takeLatest(VERIFY_PHONE_NUMBER, verifyPhoneNumber);
}

export const sagas = [
  watchCreatePassword,
  watchVerifyPhoneNumberOtp,
  watchRequestASignupLink,
  watchVerifyPhoneNumber,
  watchVerifyEmail,
];
